export const SET_INVESTMENT_DATA = 'SET_INVESTMENT_DATA';
export type SET_INVESTMENT_DATA = typeof SET_INVESTMENT_DATA;


// WEBPACK FOOTER //
// ./src/actions/investment/set-data/Types.tsx